<template>
  <div
    ref="rootRef"
    class="tags-more flex gap-x-[8px] justify-center text-14 text-font-60 cursor-pointer hover:text-font-1"
    @click="toggleExpand"
  >
    {{ expanded ? $t('shou-qi-quan-bu') : $t('zhan-kai-quan-bu') }}
    <iconpark-icon :name="iconName" />
  </div>
</template>

<script setup lang="ts">
/**
 * 这个组件并不通用，对 DOM 结构强依赖
 * class.tags-more 为了响应父级 CSS :hover
 */
const { $t } = useNuxtApp();

const rootRef = ref<HTMLElement>();
const expanded = ref(false);
const iconName = computed(() => (expanded.value ? 'arrowup' : 'arrowdown'));

function getTargetChildren() {
  const targetDOM = rootRef.value?.parentElement;
  if (targetDOM) {
    return [...targetDOM.children] as HTMLElement[];
  }
  return [];
}

function hideDOM() {
  const TargetChildren = getTargetChildren() as HTMLElement[];
  const targes = TargetChildren.slice(2, TargetChildren.length - 1);
  targes.forEach(t => {
    t.setAttribute('style', 'display: none');
  });
}
function showDOM() {
  const TargetChildren = getTargetChildren() as HTMLElement[];
  const targes = TargetChildren.slice(2, TargetChildren.length - 1);
  targes.forEach(t => {
    t.setAttribute('style', '');
  });
}

function toggleExpand() {
  if (expanded.value) {
    onUnexpand();
  } else {
    onExpand();
  }
}
function onExpand() {
  expanded.value = true;
  showDOM();
}
function onUnexpand() {
  expanded.value = false;
  hideDOM();
}

const route = useRoute();

watch(
  () => route.query.tag_ids,
  v => {
    if (v) {
      onExpand();
    }
  },
);
</script>
